import apiClient from './client';

export const NetworkAxiosInstance = apiClient;